import { useEffect, useState } from "react";
import {
  CardImage,
  CarImage,
  CenteredCarImage,
  Container,
  Description,
  Link,
  Plate,
  SideBuyBag,
  SuccessImg,
  Title,
  VehicleDescription,
  Wrapper,
} from "./success.styles";

import storageService from '../../services/storage.service';
import PaymentSuccess from '../../models/payment-sucess.entity';
import Inspection from '../../models/inspection.entity';
import { Logo } from "../Payment/components/PaymentHeader/PaymentHeader.styles";
import PlateInfo from "../../models/plate-info.entity";
import WhatsAppButton from "../Home/components/WhatsAppButton";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export default function SuccessComponent() {
  const [paymentSuccess, setPaymentSuccess] = useState(new PaymentSuccess());
  const [plateInfo, setPlateInfo] = useState<PlateInfo>(new PlateInfo());
  const [inspection, setInspection] = useState(new Inspection());

  const paymentType = localStorage.getItem('payment-type');

  const getPlateInfo = () => {
    const pInfo = storageService.getObject('plateInfo');
    setPlateInfo(pInfo);
  };

  useEffect(() => {
    const success = new PaymentSuccess(storageService.getObject('payment-sucess'));
    setPaymentSuccess(success);
    setInspection(new Inspection(storageService.getObject('inspection')));
    getPlateInfo();
  }, []);

  return (
    <Container>
      <Logo src="images/logo.svg" />
      <Wrapper>
        {paymentSuccess.protocol && (
          <>
            <SuccessImg src="images/success/success.png" />
            <CarImage src="images/success/black-car.png" />
          </>
        )}
        {paymentSuccess.number && (
          <>
            <CenteredCarImage src="images/success/black-car.png" />
            <SideBuyBag src="images/success/bag-baloon.png" />
          </>
        )}
        <Title>Oba!</Title>
        <Description>
          <b>Seu pedido de vistoria foi realizado com sucesso!</b>
          {(paymentType === 'ticket') && (
            <Description>
              Olá, <b>{inspection.name}</b>. Para realizar a sua vistoria, efetue o<br />
              pagamento do boleto e aguarde o envio do link<br />
              por SMS ou pelo Whatsapp. Isso pode levar até<br />
              um dia útil.
            </Description>
          )}
          {(paymentType === 'pix') && (
            <Description>
              Olá, <b>{inspection.name}</b>. Para realizar a sua vistoria, efetue o<br />
              pagamento com o pix e aguarde o envio do link<br />
              por SMS ou pelo Whatsapp. Isso pode levar<br />
              alguns minutos.
            </Description>
          )}
        </Description>
        {paymentSuccess.protocol && (
          <>
            <VehicleDescription>Protocolo: {paymentSuccess.protocol}</VehicleDescription>
            <Plate>Placa: {plateInfo.plate}</Plate>
          </>
        )}
        {(paymentType === 'ticket') && (
          <>
            <VehicleDescription>Baixe seu boleto agora mesmo<br />clicando no botão abaixo</VehicleDescription>
            <br />
          </>
        )}
        {(paymentType === 'pix') && (
          <>
            <VehicleDescription>Pague com Pix agora mesmo<br />clicando no botão abaixo</VehicleDescription>
            <br />
          </>
        )}

        <CardImage src="images/success/cart.png" />
        {paymentSuccess.protocol && (
          <Description>
            <br /><br />
            Agora sua vistoria veicular está<br />pronta para ser iniciada.<br /><br /><br />
            <Link
              title="Ir para vistoria"
              href={paymentSuccess.inspection}
              target="_blank"
            >Abrir vistoria</Link>
          </Description>
        )}

        {(paymentSuccess.number && paymentType === 'ticket') && (
          <>
            <Link
              title="Baixar Boleto"
              href={paymentSuccess.url}
              target="_blank"
            >
              <FileDownloadOutlinedIcon />
              Baixar boleto
            </Link>
          </>
        )}
        {(paymentSuccess.number && paymentType === 'pix') && (
          <>
            <Link
              title="Baixar Boleto"
              href={paymentSuccess.url}
              target="_blank"
            >Gerar Pix</Link>
          </>
        )}
      </Wrapper>
      <WhatsAppButton />
    </Container>
  );
};
